import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";

import { SelectForTab, IDropdownOption } from "@treelab/panda";

import FormItem from "../FormItem";

import { IFormItemChangeValue } from "../../../../types/form-type";

import { Container } from "./styled";

interface IOption extends IDropdownOption {
  labelId: string;
}

interface IProps {
  options: IOption[];
  id: string;
  onChange: (value: IFormItemChangeValue) => void;
  value: string;
}

const Select: React.FC<IProps> = ({ id, onChange, options, value }) => {
  const handleChange = useCallback(
    (value: string) => {
      onChange({ [id]: value });
    },
    [onChange, id]
  );

  return (
    <FormItem>
      <Container>
        <SelectForTab.Select
          onChange={handleChange}
          defaultActiveKey={value || options[0]?.value}
          value={value || options[0]?.value}
        >
          {options.map((item) => (
            <SelectForTab.Option currentKey={item.value}>
              <FormattedMessage id={item.labelId} />
            </SelectForTab.Option>
          ))}
        </SelectForTab.Select>
      </Container>
    </FormItem>
  );
};

export default Select;
